import { omit } from 'lodash-es'
import { hasInvalidFilenameChars } from '@/utils'

function getDefaultState() {
  return {
    data: null,
    selectedFolder: null,
    selectedFiles: {},
    selectedFilesFolder: null,
    transferWholeInputDir: null,
  }
}

const state = {
  ...getDefaultState(),
}

const getters = {
  dropboxRoot: (state) => {
    return state.data?.path
  },
  fileIds: (state) => {
    return Object.keys(state.selectedFiles)
  },
  filesCount: (state, getters) => {
    return getters.fileIds.length
  },
  filesList: (state, getters) => {
    return getters.fileIds.map((id) => {
      return { id, ...state.selectedFiles[id] }
    })
  },
  payloadFiles: (state, getters) => {
    return getters.filesList.reduce(
      (payloadFiles, file) => ({
        ...payloadFiles,
        [file.id]: omit(file, ['treeNodeSpec', 'children']),
      }),
      {},
    )
  },
  hasSelectedFiles: (state, getters) => {
    return getters.filesList.length > 0
  },
  filesUris: (state, getters) => {
    return getters.filesList.map((f) => f.uri)
  },
  transferInputDir: (state) => {
    return [state.data?.path, state.selectedFolder?.name].join('/')
    // or  return `${state.selectedFolder?.uri}`
  },
  selectedFolder: (state) => {
    return state.selectedFolder
  },
  selectedFilesFolderUri: (state) => {
    return state.selectedFilesFolder?.uri || null
  },
  selectedFilesFolderName: (state) => {
    return state.selectedFilesFolder?.name || null
  },
  invalidCharacterFiles: (state) => {
    const invalidFiles = []
    Object.values(state.selectedFiles).forEach((file) => {
      if (file && file.name && hasInvalidFilenameChars(file.relativePath)) {
        invalidFiles.push({
          id: file.id,
          name: file.name,
          hasInvalidChars: true,
          relativePath: file.relativePath,
        })
      }
    })
    return invalidFiles
  },
  hasInvalidCharacterFiles: (state, getters) => {
    return getters.invalidCharacterFiles.length > 0
  },
}

const actions = {
  async reset({ commit }) {
    commit('RESET', getDefaultState())
  },
}

const mutations = {
  RESET(state, defaultState) {
    Object.assign(state, { ...defaultState })
  },
  resetSelectedFiles(state) {
    state.selectedFiles = {}
    state.selectedFilesFolder = null
  },
  resetSelectedFolder(state) {
    state.selectedFolder = {}
  },
  setDropbox(state, dropbox) {
    state.data = dropbox
  },
  setSelectedFolder(state, folder) {
    state.selectedFolder = folder
  },
  setTransferWholeInputDir(state, transferWholeInputDir) {
    state.transferWholeInputDir = transferWholeInputDir
  },
  setSelectedFiles(state, files) {
    state.selectedFiles = {}
    files.forEach((f) => (state.selectedFiles[f.id] = f))
    state.selectedFilesFolder = files.length > 0 ? state.selectedFolder : null
  },
  addSelectedFiles(state, files) {
    files.forEach((f) => (state.selectedFiles[f.id] = f))
  },
  removeSelectedFile(state, fileId) {
    const files = { ...state.selectedFiles }
    delete files[fileId]
    state.selectedFiles = { ...files }
  },
  removeMultipleFiles(state, fileIds) {
    state.selectedFiles = omit(state.selectedFiles, fileIds)
  },
}

const dropbox = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default dropbox
